import _ from 'lodash';
import React, {useEffect} from 'react';
import {translate} from 'react-i18next';
import {useDispatch, useSelector, useStore} from 'react-redux';
import {CasinoSlice, defaultProviders} from '../../../slices/CasinoSlice';
import {Button} from '../../BaseComponent/Wrapper';
import CasinoAction from '../CasinoAction';
import {LiveCasinoSlice} from '../../../slices/LiveCasinoSlice';
import {EVENT} from '../../../events/listEvents';
import LiveCasinoAction from '../../LiveCasinoComponent/LiveCasinoAction';

const CasinoFilterBarMainCategoryComponent = props => {
	const dispatch = useDispatch();
	const currentPageContainer = useSelector(state => state.LayoutTemplateSlice.currentPageContainer);
	const selector = (state, field) => currentPageContainer === 'casinoPageContainer' ? state.CasinoSlice[field] : state.LiveCasinoSlice[field];
	const casinoFavouriteGames = useSelector(state => state.AccountsSlice.casinoFavourites) || [];
	const isCasinoFavouriteClicked = useSelector(state => selector(state, 'isCasinoFavouriteClicked'))
	const categories = useSelector(state => selector(state, 'categories'))
	const selectedCategory = useSelector(state => selector(state, 'selectedCategory'))
	const casinoActions = currentPageContainer === 'casinoPageContainer' ? CasinoSlice.actions : LiveCasinoSlice.actions;
	const isAuth = useSelector(state => state.AccountsSlice.user.auth);
	const moreCategoryWrapperRef = React.createRef();
	const store = useStore();


	const filterCasinoFavouriteGames = (casinoGames) => {
		const favouriteGames = [];
		const totalRecord = casinoFavouriteGames.length
		casinoFavouriteGames.forEach(favGame => {
			const foundedFavouriteGame = _.find(casinoGames, game => game.gameType == favGame.gameType
				&& game.gameId == favGame.gameId
				&& (currentPageContainer === 'casinoPageContainer' ? game.liveCasino === favGame.liveCasino : game.liveCasino)
			);
			if (foundedFavouriteGame) {
				foundedFavouriteGame.totalRecords = totalRecord;
				foundedFavouriteGame.isUserFavourite = true;
				favouriteGames.push(foundedFavouriteGame);
			}
		});

		dispatch(casinoActions.updateCasinoGames(_.orderBy(favouriteGames, ['gameName'], ['asc'])));
	}

	const fetchCategoryFavorites = (categoryId) => {
		dispatch(casinoActions.updateIsFetchingGames(true));
		const casinoSlice = currentPageContainer === 'casinoPageContainer' ? store.getState().CasinoSlice : store.getState().LiveCasinoSlice
		const {channelId, gameName,
			status, lang, beginIndex,
			moreItems, orderBy
		} = casinoSlice.casinoFilter;

		// Initialize casino filter from casinoStore
		const casinoFilter = {
			channelId: channelId,
			gameName: gameName,
			status: status,
			lang: lang,
			beginIndex: beginIndex,
			moreItems: moreItems,
			orderBy: orderBy,
			categoryId: categoryId, // for Favourite categorogy, we will get all games and filter favorites
		};
		const getCasinoGamesAction = currentPageContainer === 'casinoPageContainer' ? CasinoAction.getCasinoGames(casinoFilter) : LiveCasinoAction.getLiveCasinoGames(casinoFilter);
		getCasinoGamesAction.then(res => {
			if (!_.isEmpty(res)) {
				const casinoGames = _.get(res, 'casinoGames', []);
				const casinoProviders = _.get(res, 'casinoProviders', []);
				dispatch(casinoActions.updateCasinoProviders(casinoProviders));
				dispatch(casinoActions.updateCasinoProviderFilter([...defaultProviders, ...casinoProviders]));
				filterCasinoFavouriteGames(casinoGames);
			}
			dispatch(casinoActions.updateIsFetchingGames(false));
		}).catch(error => {
			dispatch(casinoActions.updateIsFetchingGames(false));
		});
	}



	const selectMainCategory = (category) => {
		dispatch(casinoActions.setCasinoFavouriteClicked(false));
		dispatch(casinoActions.selectMainCategory(category));
		dispatch(casinoActions.updateCasinoProviderFilter([]));
		currentPageContainer === 'casinoPageContainer' ?
			window.fireEvent(EVENT.CASINO_GAME_FILTER) :
			window.fireEvent(EVENT.LIVE_CASINO_GAME_FILTER);
		onCloseMoreCategory();	
	}

	const openFavouriteGames = () => {
		dispatch(casinoActions.setCasinoFavouriteClicked(true));
		dispatch(casinoActions.clearCasinoGames());
		dispatch(casinoActions.resetCasinoFilter());
		dispatch(casinoActions.resetFavoritesCategory());
		fetchCategoryFavorites(-1);
		onCloseMoreCategory();		
	}

	const onClickMoreCategory = () => {
		moreCategoryWrapperRef.current.style.display = 'flex';
	}

	const onCloseMoreCategory = () => {
		moreCategoryWrapperRef.current.style.display = 'none';
		window.scrollTo(0, 0);
	}

	const renderMoreButton = (moreCategoryItems) => {
		const className = (moreCategoryItems &&
			moreCategoryItems.some(categoryButton => categoryButton.key == selectedCategory.mainCategory.id) && !isCasinoFavouriteClicked) ||
			isCasinoFavouriteClicked ?
			'selected fal fa-check' :
			'';
		return (
			<div className="more-category-wrapper" key='more-button-wrapper'>
				<Button
					key='more-button'
					className={`${className} category-btn`}
					onClick={onClickMoreCategory}
				>
					{props.t('default:More')}
				</Button>
				<span className="down-arrow" ></span>
				<div className="more-category-dropdown" ref={moreCategoryWrapperRef}>
					{moreCategoryItems}
				</div>
			</div>
		)
	}

	const renderMainCategory = () => {
		const orderedCategories = _.orderBy(categories, ['mainCategory.orderBy', 'mainCategory.categoryName']);
		const content = _.map(orderedCategories, (value, index) => {
			const category = value['mainCategory'];
			// If this category is default category, this will be translated by i18
			const categoryName = category.isDefault ? category.categoryName : category.translationName;
			let className = (category.id === _.get(selectedCategory, 'mainCategory.id') && !isCasinoFavouriteClicked) ? 'selected fal fa-check' : '';

			return (
				<Button
					key={category.id}
					className={`${className} category-btn`}
					onClick={() => selectMainCategory(category)}
				>
					{props.t(`casino:${categoryName.trim()}`)}
				</Button>
			);
		});
		if (isAuth) {
			content.push(<Button
				key="casino-fav"
				className={`${isCasinoFavouriteClicked ? 'selected fal fa-check' : ''} category-btn`}
				onClick={() => openFavouriteGames()}
			>
				{props.t(`casino:Favorites`)}
			</Button>
			)
		}
		if (content.length > 7) {
			const moreCategoryItems = content.splice(7);
			const moreButtonWrapper = renderMoreButton(moreCategoryItems);
			content.push(moreButtonWrapper);
		}

		return (
			<div className="main-category">
				<div className="selected-category">
					{content}
				</div>
			</div>
		);
	}

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (moreCategoryWrapperRef.current && !moreCategoryWrapperRef.current.contains(event.target)) {
				moreCategoryWrapperRef.current.style.display = 'none';
			}
		}
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [moreCategoryWrapperRef]);

	return (
		<React.Fragment>
			{renderMainCategory()}
		</React.Fragment>
	);
}

export default translate([], {wait: true})(CasinoFilterBarMainCategoryComponent);



// WEBPACK FOOTER //
// ./src/app/components/CasinoComponent/CasinoFilterBarMainCategoryComponent/index.js